import { Table, TBody, Row, Cell } from "./styled";
import FormLabel from "../FormLabel";
import React from "react";
import { injectIntl } from "react-intl";

const PaymentStatusEdit = (props) => {
  const { extra = {}, intl } = props;

  const { label } = extra;

  return (
    <React.Fragment>
      {label && <FormLabel extra={{ label }} />}
      <Table>
        <TBody>
          <Row>
            <Cell>{intl.formatMessage({ id: "PaymentInfo.Amount" })}</Cell>
            <Cell></Cell>
          </Row>

          <Row>
            <Cell>
              {intl.formatMessage({ id: "PaymentInfo.CurrencyCode" })}
            </Cell>
            <Cell></Cell>
          </Row>

          <Row>
            <Cell>{intl.formatMessage({ id: "PaymentInfo.Method" })}</Cell>
            <Cell></Cell>
          </Row>

          <Row>
            <Cell>
              {intl.formatMessage({ id: "PaymentInfo.TransactionDate" })}
            </Cell>
            <Cell></Cell>
          </Row>

          <Row>
            <Cell>{intl.formatMessage({ id: "PaymentInfo.Status" })}</Cell>
            <Cell></Cell>
          </Row>

          <Row>
            <Cell>
              {intl.formatMessage({ id: "PaymentInfo.SwishPayerAlias" })}
            </Cell>
            <Cell></Cell>
          </Row>
        </TBody>
      </Table>
    </React.Fragment>
  );
};

export default injectIntl(PaymentStatusEdit);
